import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  ROOMS_MODAL_ACTION_TYPE,
  ROOMS_ALL_ACTIONS_TYPE,
} from "../../redux/actions-type";
import GlobalHead from "../../globalComponents/GlobalHead/GlobalHead";
import RoomData from "./components/RoomData";
import {
  getRoomsCalendarPaginationAction,
  getRoomsPaginationAction,
} from "../../redux/actions/roomsActions";
import HeadTabs from "../../globalComponents/HeadTabs/HeadTabs";
import { useLocation } from "react-router-dom";
import RoomCalendarData from "./components/RoomCalendarData";

const RoomsPage = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { rooms, totalLength, loading } = useSelector(
    (state) => state.roomsPagination
  );
  const { calendarData, loading: calendarLoading } = useSelector(
    (state) => state.roomsCalendarPagination
  );
  const { startDate, endDate } = useSelector((state) => state.datepicker);
  const { roomsSearchValues } = useSelector((state) => state.searchValues);

  const openModal = () => {
    dispatch({
      type: ROOMS_MODAL_ACTION_TYPE.GET_ROOMS_MODAL,
      payload: { data: {}, openModal: true },
    });
  };

  const filter = () => {
    if (loading || calendarLoading) return;

    if (location.pathname === "/room/calendar") {
      dispatch({
        type: ROOMS_ALL_ACTIONS_TYPE.RESET_ROOMS_CALENDAR_PAGINATION,
      });

      dispatch(getRoomsCalendarPaginationAction(0, startDate, endDate));
      return;
    }

    dispatch({
      type: ROOMS_ALL_ACTIONS_TYPE.RESET_ROOMS_PAGINATION,
    });

    dispatch(getRoomsPaginationAction(0, roomsSearchValues));
  };

  const getNextData = () => {
    if (loading || calendarLoading) return;

    if (location.pathname === "/room/calendar") {
      dispatch(
        getRoomsCalendarPaginationAction(
          calendarData?.length || 0,
          startDate,
          endDate
        )
      );
      return;
    }

    if (roomsSearchValues) {
      dispatch(getRoomsPaginationAction(rooms?.length || 0, roomsSearchValues));
    } else {
      dispatch(getRoomsPaginationAction(rooms?.length || 0, ""));
    }
  };

  const searchData = (e) => {
    e.preventDefault();
    dispatch({
      type: ROOMS_ALL_ACTIONS_TYPE.RESET_ROOMS_PAGINATION,
    });

    dispatch(getRoomsPaginationAction(0, roomsSearchValues));
  };

  useEffect(() => {
    if (location.pathname === "/room") {
      if (roomsSearchValues) {
        dispatch(getRoomsPaginationAction(0, roomsSearchValues));
      } else {
        dispatch(getRoomsPaginationAction(0, ""));
      }
    } else {
      dispatch(getRoomsCalendarPaginationAction(0, "", ""));
    }

    return () => {
      dispatch({
        type: ROOMS_ALL_ACTIONS_TYPE.RESET_ROOMS_PAGINATION,
      });
      dispatch({
        type: ROOMS_ALL_ACTIONS_TYPE.RESET_ROOMS_CALENDAR_PAGINATION,
      });
    };
  }, [location.pathname]);

  return (
    <div className="details-page rooms ">
      <GlobalHead
        searchData={searchData}
        openModal={openModal}
        filter={filter}
        DATA_SEARCH_VALUE={"ROOMS_SEARCH_VALUE"}
        dataSearchValues={roomsSearchValues}
        profile="rooms"
        statusType={"rooms"}
        count={totalLength}
      />

      <HeadTabs
        firstRoute={"/room"}
        secondRoute={"/room/calendar"}
        firstPathname={"Otaqlar"}
        secondPathname={"Otaq təqvimi"}
      />

      {location.pathname === "/room" ? (
        <RoomData getNextRoom={getNextData} />
      ) : (
        <RoomCalendarData getNextData={getNextData} />
      )}
    </div>
  );
};

export default RoomsPage;
